import { map } from 'lodash';
import { PipeResponse } from '../shared/pipes/pipeResponse';
import { ThermostatTypeCode } from '../shared/quote-or-design-form/quoteOrDesignFormData';
import { DesignCreateUpdateUnitDto, mapUnitFormModelToDesignDto } from '../shared/units/createUpdateUnitDto';
import {
  DesignFormModel,
  designHasHeatPump,
  designHasSolar,
  designHasUnderfloorHeating,
} from './design-form/designFormModel';

export type CreateDesignCommand = {
  createdFromQuoteId: number;
  design: CreateUpdateDesignDto;
};

export type UpdateDesignCommand = {
  design: CreateUpdateDesignDto;
};

export type CreateUpdateDesignDto = {
  designId: number | null;
  projectId: number;
  underfloorHeatingSalesOrderId: number | null;
  heatPumpSalesOrderId: number | null;
  solarSalesOrderId: number | null;
  title: string;
  revisionCode: string;
  revisionReason: string;
  qrNumber: string;
  address: string;
  isDraft: boolean;
  defaultThermostatTypeCode: ThermostatTypeCode;
  includeNeoHub: boolean;
  units: Array<DesignCreateUpdateUnitDto> | null;
};

export const mapDesignFormModelToUpdateCommand = (
  formModel: DesignFormModel,
  projectId: number,
  pipes: Array<PipeResponse>,
): UpdateDesignCommand => ({
  design: {
    designId: formModel.designId,
    projectId,
    underfloorHeatingSalesOrderId: !designHasUnderfloorHeating(formModel)
      ? null
      : formModel.underfloorHeatingSalesOrderId,
    heatPumpSalesOrderId: !designHasHeatPump(formModel) ? null : formModel.heatPumpSalesOrderId,
    solarSalesOrderId: !designHasSolar ? null : formModel.solarSalesOrderId,
    title: formModel.title?.trim() ?? '',
    revisionCode: formModel.revisionCode?.trim() ?? '',
    revisionReason: formModel.revisionReason?.trim() ?? '',
    qrNumber: formModel.qrNumber?.trim() ?? '',
    address: formModel.address?.trim() ?? '',
    isDraft: formModel.isDraft,
    defaultThermostatTypeCode: formModel.defaultThermostatTypeCode,
    includeNeoHub: formModel.includeNeoHub,
    units: map(formModel.units, (unit, unitIndex) => mapUnitFormModelToDesignDto(unit, unitIndex, pipes)),
  },
});

export const mapDesignFormModelToCreateCommand = (
  formModel: DesignFormModel,
  projectId: number,
  createdFromQuoteId: number,
  pipes: Array<PipeResponse>,
): CreateDesignCommand => ({
  createdFromQuoteId,
  ...mapDesignFormModelToUpdateCommand(formModel, projectId, pipes),
});
